<div class="result-icons-container">
	<span>{{record._index}}. </span>
	<i title="{{LOCALIZATION.viewMetadata}}" 
		(click)="viewMetadata()" 
		class="fa fa-tags" 
		aria-hidden="true">
	</i>
	<i title="{{LOCALIZATION.viewInMap}}" 
		*ngIf="record.geo && mapViewEnabled" 
		(click)="openInMap()" 
		class="fa fa-globe-americas" 
		aria-hidden="true">
	</i>
	<i title="{{LOCALIZATION.recordInformation}}" 
		*ngIf="userPermissions['ROLE_RECORDS_MANAGEMENT_VIEW'] && record.rm_record_id" 
		(click)="viewRMQuickInfo()"
		class="fas fa-folder" 
		aria-hidden="true">
	</i>
</div>
